<template>
  <div>

    <canvas id="chartreport"></canvas>
    <!-- <LoaderComponent  v-if="!isData"></LoaderComponent> -->
  </div>
</template>
<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import 'chart.js/dist/Chart.min.js'
//import LoaderComponent from "@/components/shared/LoaderComponent"

import * as Tools from './../../Tools/Tools'


export default {
  name: "ChartReportComponent",
  components:{
      //LoaderComponent
  },
  data () {
    return {
        myChart: null,
        trig: false,
        chartData: [],
      }
  },
  props:{

    bomId: Number,
    selectedReport: String

  },
  computed: {
    id () {

      return "chart_" + this._uid;
    },
    isData(){


      return this.chartData.length != 0;

    },



  },

  created() {

      this.initChart();
      this.trig = true
  },
  watch: {

    selectedReport: function () {

      this.sortData();
    }
  },

  methods: {
    initChart() {

      let vue = this;

      let obj = {
        bomId: this.bomId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBomChartReport", obj)
        .then(function (result) {

          console.log(result)

          if (result.status == "OK") {

            vue.chartData = result.data;
            vue.sortData();
          }

        })


    },
    sortData() {


      const customOrder = ["High", "Medium", "Low", "Unknown"];

      const orderMap = customOrder.reduce((acc, type, index) => {
        acc[type] = index;
        return acc;
      }, {});

      const sortedTab = [...this.chartData[this.selectedReport]].sort(
        (a, b) => orderMap[a.Type] - orderMap[b.Type]
      );


      this.chartData[this.selectedReport] = sortedTab;

      this.buildChart();
    },
    buildChart: function () {



      let vue = this;

      let fontColor = "#666666";
      let lineColor = "#cccccc";
      if (this.$store.getters.s_skinVariant == "light"){
        fontColor = "#666666";
        lineColor = "#cccccc";
      }else{
        fontColor = "#f3f3f3";
        lineColor = "#cccccc";
      }

      const values = [];
      const labels = [];
      const colors = [];

      for (let i = 0, le = this.chartData[this.selectedReport].length; i < le; i++){

        let color = "";
        if (this.chartData[this.selectedReport][i].Type == "High") {
          color = "#FF2200";
        }
        if (this.chartData[this.selectedReport][i].Type == "Medium") {
          color = "#E6B817";
        }
        if (this.chartData[this.selectedReport][i].Type == "Low") {
          color = "#247f3e";
        }
        if (this.chartData[this.selectedReport][i].Type == "Unknown") {
          color = "#3366CC";
        }

        values.push(this.chartData[this.selectedReport][i].Value);
        colors.push(color)
        let type = this.chartData[this.selectedReport][i].Type;// + " (" + this.chartData[i].Value + ")";

        labels.push(type);

      }

      var data_chart = {
        labels: labels,
        datasets: [{
        label: 'My Dataset',
        data: values,
        backgroundColor: colors,
        hoverOffset: 4
      }]
      };



      var options = {
        title: {
          display: false,
          text: ''
        },
        //aspectRatio: 3,
        maintainAspectRatio: false,
        responsive: true,
        maintainAspectRatio: true,
        onClick: function(event, legendItem) {



        },
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontColor: fontColor,
              font: {
                size: 10
              },
            boxWidth: 10,
            boxHeight: 5

          },

          onClick: function(evt, legendItem) {

            var index = legendItem.index;
            var ci = this.chart;


            var meta = ci.getDatasetMeta(0);
            meta.data[index].hidden = !meta.data[index].hidden;

            ci.update();

            let obj = meta.data;
            obj[index].obj = vue.chartData[vue.selectedReport][index];

            vue.$parent.changeNumberOfitems(obj);
          },
        },
      }



      let ctx = document.getElementById("chartreport").getContext('2d');

      if (vue.myChart) {

        vue.myChart.destroy();
      }

      vue.myChart = new Chart(ctx, {
          type: "pie",
          data: data_chart,
          options: options
      })


      Chart.defaults.global.elements.rectangle.color = 'rgba(255, 255, 255, 0.5)';
    },
    goTo: function (filterIndex, chartIndex){



    }



  }


}
</script>

<style scoped>
  canvas {
			-moz-user-select: none;
			-webkit-user-select: none;
			-ms-user-select: none;

  }
  .noData{
    margin: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ChartReportComponent.vue